import { convertPhoneNumber } from "../../utils/phone-number";
import LoginWithButton from "../LoginwithButton";
import zalo from "./../../assets/zalo.webp";
import { zaloLogin } from "./ApiService";
export default function LoginWithZaloButton({userId, phoneNumber}) {
  const handleLogin = async () => {
    try {
      phoneNumber = convertPhoneNumber(phoneNumber)
      const redirectLink = await zaloLogin(userId, phoneNumber);
      console.log("Login successful:", redirectLink);
      window.location.href = redirectLink;
    } catch (err) {
      console.error("Login failed:", err);
      // setError(err.message || "Login failed");
    }
  };
  return (
    <LoginWithButton iconimg={zalo} iconname="Zalo" onClick={handleLogin} />
  );
}
